export enum ErrorKey {
  SIGNUP_EMAIL_ALREADY_EXIST = 'SIGNUP_EMAIL_ALREADY_EXIST',
  SIGNUP_COMPANY_ALREADY_EXIST = 'SIGNUP_COMPANY_ALREADY_EXIST'
}

export enum DiscountCodeErrorKey {
  CODE_NOT_FOUND = '1',
  CODE_EXPIRED = '2',
  CODE_CANNOT_BE_APPLIED = '3',
  CLIENT_NOT_FOUND = '4'
}

export enum ComplianceLevels {
  Elite = 'CHAS Elite',
  Advanced = 'CHAS Advanced',
  Standard = 'CHAS Standard',
  VerifiedContractor = 'CHAS Verified Contractor',
  VerifiedSupplier = 'CHAS Verified Supplier'
}

export enum CompanyLocation {
  GB = 'GB',
  AU = 'AU'
}

export enum SupportServices {
  SelfServe = 'Self Serve',
  FastTrack = 'Fast Track',
  CHASAssist = 'CHAS Assist'
}

export enum ProductTypes {
  Services = 'Services'
}

export enum SurveySteps {
  YourDetails = 'Your details',
  MembershipPackage = 'Membership package',
  ApplicationType = 'Application type',
  AssessmentType = 'Assessment type',
  CompanyDetails = 'Company details',
  Order = 'Order',
  FoundationSignUp = 'Foundation Sign Up'
}

export enum MembershipTypes {
  Foundation = 'Foundation',
  Contractor = 'Contractor',
  Supplier = 'Supplier'
}
